module.exports = __webpack_public_path__ + "img/lxwm3.68ee7e86.jpg";